export default {
    required: "Campo obrigatório",
    selectionRequired: "Selecione uma opção",
    pattern: {
        email: "Endereço de e-mail inválido",
        fullName: "Nome inválido",
        mae: "Nome inválido",
        name: "Nome inválido",
        agency: "Agência inválida",
        motherName: "Nome da mãe inválido",
        fatherName: "Nome do pai inválido",
        spouseName: "Nome do cônjuge ou companheiro inválido",
        companyName: "Nome da empresa inválido"
    },
    validCPF: "Esse CPF não existe",
    invalidDate: "Essa data não é válida",
    validCNPJ: "Esse CNPJ não existe",
    dateValid: "Data inválida",
    validCNH: "Essa CNH não existe",
    MatchPassword: "As senhas não conhecidem",
    minlength: {
        phone: "Telefone inválido",
        phoneNumber: "Telefone inválido",
        cell: "Telefone inválido",
    },
    rePassword: "Senha inválida",
    password: "Senha inválida",
    customSpecialCharacterValidation: {
        name: "Informe nome e sobrenome completos, sem abreviar"
    },
    stateError: 'Error de estado',
    cityError: 'Error de cidade',
    uploadLoading: 'Upload em andamento',
    emailNotUnique: 'Você já informou esse e-mail.',
    docNumberNotUnique: 'Você já informou esse CPF/CNPJ.',
    fullName: "Nome inválido",
    fullNameWithoutSpecialCharacter: "Informe nome e sobrenome completos, sem abreviar",
    phoneError: "Número de celular inválido",
    compositeMinValuNotReached: 'Valor deve ser maior do que R$ 30,00 e menor que 10 bilhões',
    validDateToBirthday: 'Data menor que nascimento',
    validateMaxCurrencyNumber: 'Valor deve ser menor do que 10 bilhões e maior que R$ 0,00',
    validateNegativeValue: 'Valor deve ser maior ou igual a R$ 0,00',
    atLeaseOne: 'Você deve informar pelo menos uma opção',
    underAge: 'Menores de idade não podem ter uma conta',
    dateBeforeToday: 'Data inválida',
    selectionJobRequired: 'Selecione uma profissão para continuar.',
    passwordMismatch: "As senhas não coincidem",
    duplicateCpf: "CPF deve ser diferente do seu",
    duplicateName: "Nome deve ser diferente do seu"
}
